export class HEC_CONSTANTS {
	constructor() { }

	static DROPDOWN_CATEGORY_TYPE: any = [
		{ codeId: "Primary", codeValue: "Primary" },
		{ codeId: "Supplementary", codeValue: "Supplementary" },
	];
	static PUBLICATION_TYPE = {
		ResearchPaper: 10242,

		Books: 10244,

		ConferenceProceeding: 10245,

		SeminarPresentation: 10246,

		ChaptersContributed: 102410,
	};

	static PUBLICATION_SEARCH_TYPE = {
		ISSNNumber: 60081,

		JournalName: 60082,
	};

	static AUTHOR_TYPE = {
		Primary: 10231,

		Co: 10232,
	};
	static FILE_PROPERTIES_COURSERA = {
		APPLICATION_FORM: {
			fileExt: "jpeg,jpg,pdf",
			maxSize: 15000,
		},
		UNI_FOCAL_PERSON: {
			maxSize: 15000,
			fileExt: "xlsx,xls",
		},
	};

	static HTTP_RESPONSE = {
		OK: 200,
		UNAUTHORIZED: 401,
		DEVIATIONS: 412,
		PRECAUTION_REQUIRED: 428,
		BAD_RESPONSE: 422,
		NO_DATA_FOUND: 100,
		INTERNAL_SERVER_ERROR: 500,
		INVALID_ARGUMENT: 400,
		CONFIGURATION_ERROR: 5,
		DUPLICATE_RESULT: 4,
		COMMUNICATION_FAILURE: 6,
		SEARCH_COUNT_LIMIT_VIOLATED: 7,
		ENTITY_EXIST_EXCEPTION: 8,
		NADRA_SERVICE_ERROR: 9,
		ALREADY_EXIST: 10,
		BUSINESS_ERROR: 300,
		ACCOUNT_ERROR: 600,
		BLACKLISTED_ACCOUNT_ERROR: 601,
		UNVERIFIED_ACCOUNT: 602,
		BAD_REQUEST: 403,
		CODE_NOT_VERIFIED: 300,
		NOT_FOUND: 404
	};

	static CONSTANT_VALUES = {
		desFileExt: "pdf",
		maxSize: 10000,
		fileExt: "png, pdf",
		fileExtEmail: "msd,pst,edb,eml,msg",
		imageFileExt: "jpg, jpeg, png",
		fileAllowedFormat: /^[0-9_a-z-A-Z(.) ]+$/,
		Comments_Character_Allowed: 500,
		Alive_Status: 10031,
		Single_Marital_Status: 10021,
		Islam_Religion: 10271,
		PK_Country_Code: 1,
		Father_Status_Default: 0,
		Identity_Cnic_Type: 10282,
		Address_Type_Mailing: 10202,
		DEFAULT_IMG_PATH: "/assets/media/users/default.jpg",
		MAX_TOTAL_MARKS: 9999,
		PAKISTAN_COUNTRY_ID: 1,
		REVISION_REQUESTED: 600827,
		NEW_ATTESTATION: 600181,
		DUPLICATE_ATTESTATION: 600184,
		SAVED_ATTESTATION: 60081,
		ISB_REGIONAL_CENTER: 1,
		URGENT_FEES: 3000, // DAS_CHANGE
		IS_INSIDE_PAKISTAN: 1,
	};
	static APP_FORM_VIEWS = {
		FORM_EDIT: "edit",

		FORM_VIEW: "view",

		FORM_DOWNLOAD: "download",
	};

	static ADMIN_CONSTANT_VALUES = {
		APPCOUNT_CHARTTYPE: "pie",
		APPCOUNT_BACKGROUND: "transparent",
		TITLE_FONTSIZE: "24px",
		SUBTITLE_FONTSIZE: "10px",
		TITLE_FONTFAMILY: "popin-semibold",
		SUBTITLE_FONTFAMILY: "popin-light",
		SUBTITLE_TEXT: "Task Performed",
		DAYWISE_GRAPH_TYPE: "line",
		DAYWISE_GRAPH_COLOR: "transparent",
		DAYWISE_TITLE_TEXT: "Number of Application",
	};

	static ATTESTATION_MODE = {
		NORMAL: 6003301,
		URGENT: 6003302,
		COURIER: 6003303,
		ONLINE: 6003304,
	};

	static Education_Level = [
		{ value: "MPhil", code: 101023 },
		{ value: "PostDoctorate", code: 101024 },
		{ value: "MSDegree", code: 131 },
		{ value: "Doctorate_Degree", code: 132 },
		{ value: "MSleadingToPhD", code: 101025 }
	];

	static Management_Types = {
		ADMINISTRATIVE_PANEL: {
			artifact_id: 300128,
			team_code_id: 209203,
			code_value: "Create Administrative Panels",
		},
		DISCIPLINARY_PANEL: {
			artifact_id: 300123,
			team_code_id: 209204,
			code_value: "Create Disciplinary Panels",
		},
		THEMATIC_PANEL: {
			artifact_id: 300124,
			team_code_id: 209202,
			code_value: "Create Thematic Panels",
		},
		JMP_PANEL: {
			artifact_id: 300125,
			team_code_id: 209201,
			code_value: "Create Joint Multidisciplinary Panels",
		},
		STEERING_COMMITTEE_PANEL: {
			artifact_id: 300126,
			team_code_id: 209205,
			code_value: "Create Steering Committee Panels",
		},
		HLEP_PANEL: {
			artifact_id: 300127,
			team_code_id: 209206,
			code_value: "Create  High Level Evaluation Panels",
		},
	};

	static ERROR_MESSGAES = {
		COI_Identified:
			"Conflict of Interest has been identified! The application will be reverted back to the assigner",
		Review_Submitted: "Your review has been submitted successfully.",
		Evaluation_Submitted:
			"Your Evaluation has been submitted successfully.",
		Program_Chair_Decision: "Your decision has been saved successfully.",
		JMP_Decision: "Your decision has been saved successfully.",
		Program_Chair_Final_Decision:
			"Your decision has been saved successfully.",
		Invalid_Login: "Invalid cnic or password",
		NON_RGA_USER_MESSAGE:
			"Dear User, No Role has been assigned to you yet. Please contact system administrator",
		NO_ROLE_MSG: "No Role is assigned to the particular member",
		LOCKED_ACCOUNT:
			"Your account has been locked. Please press on Forget Password link to reset your account",
		BLACKLISTED_ACCOUNT:
			"Your account is blacklisted. Please contact rgms@hec.gov.pk for further information",
		VERIFICATION_CODE_SENT:
			"Verification code has been sent to your E-mail",
		CELL_ALREADY_REGISTERED: "Cell Phone is already registered",
		EMAIL_ALREADY_REGISTERED: "Email is already registered",
		EMAIL_CODE_NOT_VALID: "Email verification code is not valid",
		SMS_CODE_NOT_VALID: "SMS verification code is not valid",
		CODES_NOT_VALID:
			"Email verification code is not valid, SMS verification code is not valid",
		SMS_CODE_SENT: "Cell Phone Verification Code Sent",
		EMAIL_CODE_SENT: "Email Verification Code Sent",
		EMAIL_NOT_EXIST: "Email address doesn't exist",
		USERID_NOT_EXIST: "User ID address doesn't exist",
		VERIFICATION_CODE_SENT_EMAIL:
			"Verification Code has been sent on email",
		PASSWORD_UPDATED: "Password is updated Successfully",
		SOMETHING_WENT_WRONG: "Something Went Wrong",
		SESSION_TIMEOUT: "Session Timeout",
		NO_DATA_FOUND_FOR_PANEL: "NO DATA FOUND FOR THE ABOVE PANEL",
		NO_SLIDER_DATA: "No active slider found!"
	};

	static Member_Types = {
		BY_DISCIPLINARY_PANEL: {
			codeId: 209801,
			codeValue: "Add From Disciplinary Panels",
		},
		BY_INVITATION: {
			codeId: 209803,
			codeValue: "Invitation",
		},
		BY_USER_PROFILE: {
			codeId: 209802,
			codeValue: "Search Profile",
		},
	};

	static DROPDOWN_FILTER_USER_PROFILE: any = [
		{ codeId: "cnic", codeValue: "CNIC" },
		{ codeId: "email", codeValue: "Email" },
	];

	static MANUAL_LIST = [
		{ title: "Portal Manual", fileName: "Portal-Manual.pdf" },
		{ title: "Dashboard Manual", fileName: "Dashboard-Manual.pdf" },
		{
			title: "Common Profile Manual",
			fileName: "CommonProfile-Manual.pdf",
		},
		{
			title: "Degree Attestation Application Request Manual",
			fileName: "DegreeAttestationApplication-Manual.pdf",
		},
		{ title: "Profile Manual", fileName: "Profile-Manual.pdf" },
		{ title: "Education Manual", fileName: "Education-Manual.pdf" },
		{
			title: "Attestation Details Manual",
			fileName: "AttestationDetails-Manual.pdf",
		},
		{
			title: "Document Upload Manual",
			fileName: "DocumentUpload-Manual.pdf",
		},
		{
			title: "Verify Details Manual",
			fileName: "VerifyDetails-Manual.pdf",
		},
		{
			title: "Forgot Password Manual",
			fileName: "ForgotPassword-Manual.pdf",
		},
		{ title: "Sign In Manual", fileName: "SignIn-Manual.pdf" },
		{ title: "Sign Up Manual", fileName: "SignUp-Manual.pdf" },
		{
			title: "Cancel Application Manual",
			fileName: "CancelApplication-Manual.pdf",
		},
		{
			title: "Application Scheduling/Rescheduling Manual",
			fileName: "ApplicationSchedulingRescheduling-Manual.pdf",
		},
		{
			title: "Revision Requested Manual",
			fileName: "RevisionRequested-Manual.pdf",
		},
		{
			title: "Upload Courier Manual",
			fileName: "UploadCourier-Manual.pdf",
		},
		{
			title: "Upload Additional Documents Manual",
			fileName: "uploadAdditionalDocument-Manual.pdf",
		},
		{ title: "DES Profile Manual", fileName: "Profile-Manual.pdf" },
		{
			title: "Detail of Degree Manual",
			fileName: "Detail-of-Degree-Manual.pdf",
		},
		{
			title: "Equivalence Details Manual",
			fileName: "Equivalence-Details-Manual.pdf",
		},
		{
			title: "DES Upload Document Manual",
			fileName: "Document-Upload-DES-Manual.pdf",
		},
		{
			title: "DES Verify Details Manual",
			fileName: "Verify-Details-DES-Manual.pdf",
		},
		{ title: "DES User Tasks Manual", fileName: "User-Tasks-Manual.pdf" },
		{
			title: "Payment Verification Manual",
			fileName: "Payment-Confirmation-Manual.pdf",
		},
		{
			title: "DES Cancel Application",
			fileName: "Cancel-Application-DES-Manual.pdf",
		},

		{
			title: "Foreign DES Profile Manual",
			fileName: "DESF-Profile_Manual.pdf",
		},
		{
			title: "Foreign DES Detail of Degree Manual",
			fileName: "DESF-Detail_Of_Degree_Manual.pdf",
		},
		{
			title: "Foreign DES Equivalence Details Manual",
			fileName: "DESF-equivalence_Manual.pdf",
		},
		{
			title: "Foreign DES Upload Document Manual",
			fileName: "DESF-Upload_Document_Manual.pdf",
		},
		{
			title: "Foreign DES Verify Details Manual",
			fileName: "DESF-verifydetails-Manual.pdf",
		},
		{
			title: "Foreign DES User Tasks Manual",
			fileName: "DESF_User_Task_Manual.pdf",
		},
		{
			title: "Foreign DES Payment Verification Manual",
			fileName: "DESF-Payment-Manual.pdf",
		},
		{
			title: "Foreign DES Cancel Application",
			fileName: "DESF-Cancel_application_Manual.pdf",
		},
	];

	static FOREIGN_EMBASSY_DOWNLOAD_CODES = {
		CNIC: "NewDasForeignEmbassyCnic",
		STAMP_NO: "NewDasForeignEmbassyStamp",
	};

	static HEC_DAS_MARITAL_STATUS = [
		{ label: "Single", value: 10021 },
		{ label: "Married", value: 10022 },
	];

	static DAY_WISE_GRAPH_OPTIONS = [
		{ label: "Current Week", value: 70001 },
		{ label: "Last Week", value: 70002 },
		{ label: "Current Month", value: 70003 },
		{ label: "Last Month", value: 70004 },
		// {label: "Current Year",value: 70005},
	];

	static DAY_WISE_GRAPH_VALUES = {
		CURRENT_WEEK: 70001,
		LAST_WEEK: 70002,
		CURRENT_MONTH: 70003,
		LAST_MONTH: 70004,
		// CURRENT_YEAR:70005,
	};

	// static DISCIPLINE_OPTIONS = [
	// 	{ label: "01 Education", value: '01 Education' },
	// 	{ label: "02 Arts and humanities", value: '02 Arts and humanities' },
	// 	{ label: "03 Social sciences, journalism and information", value: '03 Social sciences, journalism and information' },
	// 	{ label: "04 Business, administration and law", value: '04 Business, administration and law' },
	// 	{ label: "05 Natural sciences, mathematics and statistics", value: '05 Natural sciences, mathematics and statistics' },
	// 	{ label: "06 Information and Communication Technologies (ICTs)", value: '06 Information and Communication Technologies (ICTs)' },
	// 	{ label: "07 Engineering, manufacturing and construction", value: '07 Engineering, manufacturing and construction' },
	// 	{ label: "08 Agriculture, forestry, fisheries and veterinary", value: '08 Agriculture, forestry, fisheries and veterinary' },
	// 	{ label: "09 Health and welfare", value: '09 Health and welfare' },
	// 	{ label: "10 Services", value: '10 Services' },

	// 	// {label: "Current Year",value: 70005},
	// ];
	static DISCIPLINE_OPTIONS = [
		"01 Education",
		"02 Arts and humanities",
		"03 Social sciences, journalism and information",
		"04 Business, administration and law",
		"05 Natural sciences, mathematics and statistics",
		"06 Information and Communication Technologies (ICTs)",
		"07 Engineering, manufacturing and construction",
		"08 Agriculture, forestry, fisheries and veterinary",
		"09 Health and welfare",
		"10 Services",

		// {label: "Current Year",value: 70005},
	];
	static DISCIPLINE_OPTIONS_VALUES = {
		DEFAULT_VALUE: '01 Education',

		// CURRENT_YEAR:70005,
	};

	static MESSGAES_LIST = {
		AuthMessages: {
			INVALID_ACCOUNT: "Invalid cnic or passport.",
			LOCKED_ACCOUNT:
				"Your account is locked due to unsuccessful attempts to enter incorrect password. Please click on “Forget Password” and retrieve your password. In future please be careful while entering your password”.",
			UNVERIFIED_ACCOUNT:
				"Your Account is not verified,please contact the administrator.",
			BLACKLISTED_DOMAIN:
				"Your Email Domain is blacklisted. Kindly contact call center (051-111-119-432) or online help (onlinehelp.hec.gov.pk) and register your complaint for support.",
			BLACKLISTED_ACCOUNT:
				"Your account has been temporarily blocked, Kindly contact call center (051-111-119-432) or online help (onlinehelp.hec.gov.pk) and register your complaint for support.",
			Invalid_Login: "Invalid cnic or password",
			INVALID_PASSWORD: "Invalid password",
			OPT_SUCCESS_CODE:
				"Enter OTP Code sent to your registered Email Address and Phone Number",
			EMAIL_SUCCESS_CODE:
				"Enter OTP Code sent to your registered Email Address",
			EMAIL_ALREADY_REGISTERED: "Email is already registered",
			CELL_ALREADY_REGISTERED: "Cell Phone is already registered",
			EMAIL_CELL_ALREADY_REGISTERED:
				"Email and Cell Phone is already registered",
			CELL_PHONE_CODE_RESEND: "Cell Phone Verification Code is Resent",
			EMAIL_CODE_RESEND:
				"Email Verification and Phone Number Verification Code is Resent",
			PHONE_NUMBER_CODE_INVALID:
				"Phone Number Authentication Code is not correct",
			EMAIL_CODE_INVALID: "Email Authentication Code is not correct",
			ACCOUNT_CREATED:
				"Your account has been successfully registered. Please use your registered CNIC/Passport to login",
			CNIC_ALREADY_REGISTER:
				"CNIC is already registered. Please use a different one",
			POC_ALREADY_REGISTER:
				"POC is already registered. Please use a different one",
			PASSPORT_ALREADY_REGISTER:
				"Passport is already registered. Please use a different one",
			OVERSEAS_PAKISTANI_WARNING:
				'Warning: Overseas and dual national Pakistanis must select "Pakistan" as their Country of Nationality',
			VERIFICATION_CODE_SENT: "Verification Code is sent",
			FORGETPASSWORD_VERIFICATION_CODE_SENT: "Verification Code sent to ",
			EMAIL_NOT_EXIST: "Email address doesn't exist",
			CNIC_PASSPORT_NOT_EXIT: "CNIC/Passport address doesn't exist",
			CELL_NOT_EXIT: "Cell Number doesn't exist",
			VERIFICATION_RESEND: "Verification Code is Resent",
			AUTHENTICATION_INVALID: "Authentication code is not valid",
			COURSERA_BATCH_INACTIVE: "Application registration for E-Courses - Phase III – Cohort-I is closed.",
			COURSERA_APPLICATION_EXIST: "You can't apply in this cohort as you have already availed Coursera License in first Cohort.",
			COURSERA_APPLICATION_Saved_SUBMITTED: "You already have a Saved/Submitted application. Please open the application from dashboard.",
			COURSERA_BATCH_INFO: "E-Courses - Phase III – Cohort-I",
			COURSERA_APPLICATION_INFO: "Application for E-Courses - Phase III – Cohort-II"
		},
		AppSchedulingMessages: {
			ERROR_CANCELLING_APP: "Error in Cancelling Appointment",
			SUBMISSION_ERROR:
				"Error in Submission Schedulling, please try again",
			PAYMENT_ERROR:
				"Please verify your 1-Link payment before schedule submission.",
			NO_ACTIVE_APPLICATION: "No Active Application found",
			APPLICATION_SCHEDULLING: "Application Schedulling",
			APPOINTMENT_BOOKED: "Appointment Booked",
		},
		AuthorizationPersonMessages: {
			CANNOT_ACCESS:
				"You can't access this screen at the moment, please try again later",
			SOMETHING_WENT_WRONG:
				"Something went wrong, please try again later or contact administrator.",
			UPDATE_SUCCESSFULLY:
				"Authorize person details updated successfully.",
			CANNOT_UPDATE_NOW:
				"Authorize person details can not be updated at current stage.",
		},
		FeedbackMessages: {
			ERROR_SUBMITTING: "Error in submitting feedback",
		},
		ForeignEmbassyMessages: {
			AUTHORIZE_ONLY: "Only authorized focal person are allowed.",
			SOMETHING_WENT_WRONG:
				"Something went wrong please try again later.",
			NO_RESULT: "No Data Found",
			NO_RESULT_ATTESTATION: "For degree details, Please consult HEC Attestation Division.",
			NO_RESULT_EQUIVALENCE: "For degree details, Please consult HEC Equivalence Division.",
			CONTACT_ADMIN:
				"Something went wrong please try again later or contact administrator",
			CNIC_OR_UNI: "Please provide valid cnic/passport number and University.",

			CNIC_OR_STAMP: "Please provide valid cnic/passport number and stamp number.",
			CNIC_OR_PASSPORT: "Please provide valid cnic/passport number or stamp number.",
			CNIC_AND_REFERENCE_NO: "Please provide valid cnic/passport number and reference number.",
			INVALID_INPUT: "Invalid input",
		},
		DESVerificationMessages: {
			CNIC_OR_REF:
				"Please provide CNIC Number, Reference Number and Verification Key",
			CNIC: "Please provide valid CNIC.",
			VERIFICATION_KEY_INVALID: "Invalid Verification Key",
			NO_RESULT: "No Data Found",
			INVALID_INPUT: "Invalid input",
		},
		UploadAdditionalDocumentMessages: {
			ERROR_SUBMITTING: "Error in submitting application",
			SELECT_DOCUMENT:
				"Please select at least one document from the list",
			WARNING_FOR_OTHER_OPTIONS:
				"Please examine above categories carefully and upload document(s) here only if same is not covered in above categories",
		},
		UploadCourierMessages: {
			UPLOAD_RECEIPT: "Please upload courier receipt.",
			SUCCESSFULLY_UPLOADED: "Courier data uploaded successfully.",
			DISPATCH_SUCCESSFULLY: "Courier dispatch successfully.",
			SELECT_DATES: "Please Select Start and End Date",
			END_DATE_SELECTION: "Please Select the end date",
			SOMETHING_WENT_WRONG:
				"Something went wrong please try again or contact administrator.",
		},
		dasApplicationMessages: {
			ALREADY_SUBMITTED:
				"You already have a Submitted application. Please open the application from dashboard",
			ALREADY_SUBMITTED_DES:
				"You already have a Submitted/Saved/Pending Degree Equivalence application. You cannot apply for Degree Attestation until the Degree Equivalence processing completed",
			ALREADY_SAVED:
				"You already have a saved application. Please open the application from dashboard",
			ERROR_CANCEL_APP: "Error in Cancelling Application",
			CONFIRMATION_CANCEL_APP:
				"Are you sure you want to cancel this application ?",
			INSTRUCTIONS_HEADING: "Degree Attestation Form - Instructions",
			EDUCATION_VIEW_MODE:
				"You're in View mode! please click Cancel button to continue with your Application Form",
			EDUCATION_EDIT_MODE:
				"You're in Edit mode! To exit, please click Cancel button to continue with your Application Form",
			APP_ALREADY_EXISTS: "Application is already Exist",
			SELECT_ATLEAST_EDUCATION: "Please Select at least one education",
			ADD_ATLEAST_DOCUMENT:
				"Please provide Number of Pages for Photocopy/Original Documents for at least one Degree/Transcript/Provisional Certificate/Equivalence Certificate",
			INCORRECT_STAMP_NO: "Incorrect Stamp Number",
			REQUIRED_DOCUMENTS: "Please Upload All Mandatory Documents",
			NADRA_NOT_AVAILABLE:
				"We are unable to confirm your CNIC from NADRA. Please try again later. For further details, kindly contact at info.ana@hec.gov.pk.",
			SAVE_APPLICATION_ERROR: "Somethng Went Wrong!, Please try again",
		},
		Coursera: {
			COURSERA_INSTRUCTION_FORM: "Coursera Instructions",
		},
		profileMessages: {
			MANDATORY_EDUCATION_ERROR: "<p>Please add education in the following order</p><ul><li>SSC / Matriculation / O' level’s</li><li>HSSC / Intermediate / A' level’s</li><li>Bachelor’s / PGD</li><li>Master’s / M-Phil</li><li>Doctorate Degree</li><li>Post Doctorate</li></ul>",//"Please add the education in following order 		           Matric",//"Please add education details of Matriculation/ O' level’s and Intermediate/ A' level’s in Education Details on My Profile",
			ATTESTATION_PRE_REQ: 'The Attestation case may only be processed if all Bachelor onwards Degrees/Transcripts are attested from HEC Attestation Department. Please select the other degree(s) which are not attested as well.',
			NATIONALITY_REQUIRED: "Primary Nationality is Required",
			ERROR_SAVING_ADDRESS: "Error in saving address",
			ERROR_PROFILE: "Error in saving profile",
			PROFILE_PICTURE_ERROR: "Profile Picture is required",
			UPLOAD_PICTURE_ERROR: "Error in uploading profile picture",
			UPDATE_EMAIL_REQ:
				"Verification Code is sent to your entered email address, Enter verification code below",
			ALREADY_EXISTS_EMAIL:
				"An account with the entered email address already exists! Please enter a different email address",
			EMAIl_UPDATE_SUCCESS: "Email is updated successfully",
			AUTHENTICATION_CODE_INVALID: "Authentication Code is not correct",
			PASSWORD_WARNING:
				"Once your password is updated, you will be logged out of EServices Portal! You will need to Sign In back with the updated password.",
			OLD_PASSWORD_INVALID: "Your old password is not correct",
			UPDATE_PHONE_REQ:
				"Verification Code is sent to your entered mobile number, Enter verification code below",
			ALREADY_EXISTS_PHONE:
				"An account with this mobile number is already exists",
			PHONE_UPDATE_SUCCESS: "Phone Number is updated successfully",
			ADDRESS_UPDATED_SUCCESS:
				"Your Address has been successfully updated",
			ERROR_EDUCATION_DELETE: "Error in deleting Education",
			EDUCATION_SUCCESS: "Education Update Successfully",
			EDUCATION_ADDED_SUCCESS: "Education Added Successfully",
			PROFILE_UPDATED_SUCCESS:
				"Your profile has been successfully updated",
			SOMETHING_WENT_WRONG: 'Something went wrong',
			PHD_EDUCATION_MANDATORY: 'PHD / Doctorate Education is mandatory to proceed',
			PCD_SUBJECT: 'Please select subject in accordance with UNESCO (ISCED) Subject Specialization in PHD / Doctorate Education',
		},
		educationalMessages: {
			MANDATORY_MSG:
				"Please fill all the mandatory fields with valid data",
			ERROR_SUBMITTING: "Error in saving education form",
			END_DATE_GREATER: "End date should be greater than Start date",
		},
		ApplicationFormMessages: {
			SAVED_FORM:
				'Your Application is saved and can be accessed from "My Application" section from Dashboard',
			SUBMITTED_FORM:
				'Your Application is Submitted and can be accessed from "My Application" section from Dashboard',
		},
		VERIFICATION_CODE_SENT:
			"Verification code has been sent to your E-mail",
		EMAIL_CODE_NOT_VALID: "Email verification code is not valid",
		SMS_CODE_NOT_VALID: "SMS verification code is not valid",
		CODES_NOT_VALID:
			"Email verification code is not valid, SMS verification code is not valid",
		SMS_CODE_SENT: "Cell Phone Verification Code Sent",
		EMAIL_CODE_SENT: "Email Verification Code Sent",
		USERID_NOT_EXIST: "User ID address doesn't exist",
		PASSWORD_UPDATED: "Password is updated Successfully",
		SOMETHING_ERROR: "Something went wrong!",
		CAPTCHA: "Captcha is not valid",
		SOMETHING_LATER_ERROR: "Something went wrong, please try later",
		MANDATORY_DECISION:
			"Decision must be selected while submitting application",
		UPLOAD_SUCCESS: "Document Uploaded Successfully.",
		DES_ADMIN: {
			ADMIN_TITLE: "Admin Portal",
			CLAIM_TASK:
				"Are you sure you want to claim this application?, Your team will not able to claim/see this application after your claim!",
			VERFIY_DEGREE: "Are you sure you want to verify this degree?",
			APPROVE_APPLICANT:
				"Are you sure you want to approve this applicant?",
		},
	};

	static DEGREE_ATTESTATION_RATE = {
		OLD_ORIGINAL: 800,
		OLD_COPY: 500,
		NEW_ORIGINAL: 3000,
		ORIGINAL: 1000,
		COPY: 700,
	};

	static DEGREE_DOCUMENT_TYPES = {
		ORIGINAL_DOCUMENT: 60061,
		PHOTOCOPY_DOCUMENT: 60062,
	};

	static PAGES_NAME = {
		UPDATE_AUTHORIZE: "Update Authorize Person Page",
		APPLICATION_RESCHEDULING: "Application Rescheduling Page",
		APPLICATION_SCHEDULLING: "Application Scheduling Page",
		APPLICATION_TRACKING: "Application Tracking Page",
		FEEDBACK: "Feedback Page",
		FOREIGN_EMBASSY: "Foreign Embassy Page",
		NOTIFICATION_LIST: "Notification List Page",
		TRACK_APPLICATION: "Track Your Applications Page",
		UPLOAD_ADDITIONAL_DOC: "Upload Additional Documents Page",
		UPLOAD_COURIER: "Upload Courier Page",
		DASHBOARD: "Dashboard Page",
		DAS: "DAS Application Form Page",
		DAS_REVISION: "DAS Revision Requested Page",
		DAS_PROFILE: "DAS Profile Detail Page",
		DAS_EDUCATION: "DAS Education Details Page",
		DAS_ATTESTATION: "DAS Attestation Details Page",
		DAS_UPLOAD: "DAS Upload Document Page",
	};

	static DEVICES_TYPES = {
		DESKTOP: "desktop",
	};

	static DOCUMENT_TYPES = {
		OPTIONAL: "Optional",
		DEGREE: "Copy of Degree",
		TRANSCRIPT: "Copy of Transcript",
		PROVISIONAL: "Copy of Provisional Certificate",
		EQUIVALENCE: "Copy of Equivalence Certificate",
	};

	static DOCUMENT_CATEGORIES = {
		APPLICATION_FORM: "ApplicationForm",
		UPLOAD_COURIER: "Courier Upload",
		PERSONAL: "Personal Tab",
		EDUCATION: "Education",
		DESEDUCATION: "DESEducation",
	};

	static DOCUMENT_CLICKED_TYPE = {
		VIEW: "view",
		DOWNLOAD: "download",
	};

	static NOTIFICATION_SERVICES_TYPES = {
		DAS: "DAS",
		LOCAL_DES: "DES",
		CMNPROF: "CMNPROF",
	};

	static NOTIFICATION_TYPES = {
		ALERT: 703801,
		LOGS: 703802,
		TASK: 703803,
	};

	static APPLICATION_STATUSES_CODES = {
		Appintment_Booked: 600111,
		Status_Booked: 600101,
		Scheduling_Username_Type: 600191,
		SAVED: 90011,
		SUBMITTED: 90012,
		PENDING: 900121,
		APPLICATION_PROCESSING: 90014,
		APPROVED: 90015,
		PRE_APPROVED: 900155,
		REJECTED: 90016,
		REVISION: 202620,
		REVISION_REQUESTED: 90017,
		LOCAL_DES_CANCELLED: 900139,
		BLOCKED: 900204,
		PAYMENT_PENDING: 900206,
		REVOKED: 900196,

		// SAVED_BY_CONTROLLER: 900197,
		// SUBMITTED_BY_CONTROLLER: 900198,
		APPROVED_BY_CONTROLLER: 900199,
		REJECTED_BY_CONTROLLER: 9001101,
		REVISION_REQUESTED_BY_CONTROLLER: 9001102,
		REVISION_REQUESTED_BY_HEC: 9001103,
		APPROVED_BY_HEC: 900160,
		REJECTED_BY_HEC: 900161,
		REVISION_SUBMITTED_BY_APPLICANT: 202610,
		REVISED_BY_HEC_APPROVER_TO_APPLICANT: 20266,
		/** DAS dashboard: show status column as Approved (UFP/HEC workflow). */
		DAS_APPROVED_STATUS_CODE: 20264,

	};

	static DEGRESS_STATUSE_CODES = {
		REJECTED_DEGREE: 60093,
	};

	static MBA_TITLES = [
		"Master of Business Administration 3.5 Years",
		"Masters in Business Administration (MBA 3.5 years)",
		"MBA (3.5 years)",
		"Master of Law (LLM)",
		"Master of Business Administration (3.5 Years)",
		"Master of Business Administration",
		"Master of Business Administration",
		"Master of Business Administration (Three and a half-years)",
		"MASTER OF BUSINESS ADMINISTRATION (MBA 3.5 YEARS)",
		"|Master of Business Administration - 3.5 Years",
		"Master of Business Administration",
		"Master of Business Administration (3.5 Year)",
		"Master of Science in Management Sceinces",
		"MBA(Insurance & Risk Management)",
		"MBA (3.5)|Master/ MS (18 Years) Degree",
		"Masters of Business Administration",
		"Master of Commerce",
		"Master of Business Administration",
		"Master in Business Administration",
		"Master of Business and Information Technology",
		"Master of Business Administration 1.5 Years",
		"Master in Business Administration 1.5 Years",
		"MBA (Banking & Finance)",
		"MBA (Insurance & Risk Management)",
		"Master of Commerce (3.5 Years)",
		"Master of Business Administration",
		"Master of Business Administration (3.5 Yrs)",
		"Master of Business Administration (ITM) 3.5",
		"Master of Business Administration (Equivalent to MS)",
		"Master of Business Administration - 3.5 Years",
		"Master of Business Administration 3.5 Years",
		"Master of Business Administration (3 1/2 year)- Agribusiness Management",
		"Master of Business Administration (3 1/2 year) Banking & Finance",
		"Master of Business Administration (3 1/2 year) Human Resource Management",
		"Master of Business Administration (3 1/2 year)- Management",
		"Master of Business Administration (3 1/2 year)- Management Information System",
		"MASTER OF BUSINESS ADMINISTRATION (MBA 3.5 YEARS)",
		"Master of Business Administration (Three & half years)",
		"Master of Business Administration (3.5 year program)",
		"Master of Business Administration (3.5 Years)",
		"Master of Business Administration (MBA 3 1/2 year) Agribusiness Management",
		"Master of Business Administration (MBA 3 1/2 year) Banking & Finance",
		"Master of Business Administration (MBA 3 1/2 year) Human Resource Management",
		"Master of Business Administration (MBA 3 1/2 year) Management",
		"Master of Business Administration (MBA 3 1/2 year) Management Information System",
		"Master of Business Administration (MBA 3 1/2 year) Marketing",
		"Master of Business Administration (Marketing of Financial Services) 3.5 Years",
		"Master of Business Administration (Banking & Finance) 3.5 Years",
		"Master of Business Administration (Three and Half years)",
		"Master of Business Administration (Three and Half Year)",
		"Master of Business Administration (Finance) 3.5Years",
		"Master of Business Administration (Marketing) 3.5 Years",
		"Master of Business Administration (Three and Half Years)",
		"Master of Business Administration Three and Half Years",
		"Master of Business Administration 3.5",
		"Master of Business Administration (3.5 Year)",
		"Master of Business Administration (3.5-year)",
		"Master of Business Administration (3 1/2 Years)",
		"Master of Business Administration (Three and a half-years)",
		"Master of Business Administration (Equivalent to M.Phil)",
		"Master of Business Administration (3 1/2 Year Course)",
		"Master in Business Administration (Banking & Finance)",
		"Master in  Business Administration   (Banking & Finance)",
	];

	static FORM_VIEW_TYPES = {
		VIEW: "view",
		EDIT: "edit",
		DAS_REVISION_REQUESTED: "dasRevision",
		LOCAL_DES_REVISION_REQUESTED: "desRevision",
		FOREIGN_DES_REVISION_REQUESTED: "desfRevision",
		DAS: "das",
		DES: "DES",
	};

	static SUGGESTED_SERVICES = [
		{
			icon: "flaticon2-file kt-font-focus",
			desc: "DASHBOARD.SUGGESTED_SERVICES.APPLY_DAS",
			url: "/#/das-app",
			buttonClass: "btn-label-brand",
		},
		{
			icon: "flaticon2-file kt-font-focus",
			desc: "Apply For Local Degree Equivalence Service",
			url: "/#/localdes",
			buttonClass: "btn-label-brand",
		},
		{
			icon: "flaticon2-file kt-font-focus",
			desc: "Apply For Foreign Degree Recognition/Equivalence Service",
			url: "/#/foreigndes",
			buttonClass: "btn-label-brand",
		},
		//coursera active route disabled on 2nd November 2022

		//coursera active route disabled on 6th April 2023
		{
			icon: "flaticon2-file kt-font-focus",
			desc: "Apply For Ecourses (DLSEI 3.0)",
			url: "/#/ecourses",
			buttonClass: "btn-label-brand",
		},
		// {
		// 	icon: 'flaticon2-file kt-font-focus',
		// 	desc: 'Madrsa Degree Equivalence Service',
		// 	url: '/#/foreigndes',
		// 	buttonClass: 'btn-label-brand'
		// },
	];

	static DAS_TABS = {
		PROFILE_DETAILS: 1,
		EDUCATION_DETAILS: 2,
		ATTESTATION_DETAILS: 3,
		UPLOAD_DETAILS: 4,
		VERIFY_DETAILS: 5,
	};
	static PCD_STATUSES_VALUES = [
		// { label: "Current Week", value: 70001 },
		{ label: "Saved By Applicant", value: 4042001 },
		{ label: "Submitted By Applicant", value: 4042002 },
		{ label: "Revision Requested By Controller", value: 4042003 },
		{ label: "Approved By Controller", value: 4042005 },
		{ label: "Rejected By Applicant", value: 4042004 },
		{ label: "Application in Process", value: 4042006 },
		{ label: "Approved By Hec", value: 4042007 },
		{ label: "Rejected By Hec", value: 4042008 },
		{ label: "Revision Requested  By Hec", value: 4042009 },



	];
	static PCD_STATUSES = {
		SAVED_BY_APPLICANT: 4042001,
		SUBMITTED_BY_APPLICANT: 4042002,
		REVISION_REQUESTED_BY_CONTROLLER: 4042003,
		// SUBMITTED_BY_CONTROLLER: 4042004,
		APPROVED_BY_CONTROLLER: 4042005,
		REJECTED_BY_CONTROLLER: 4042004,
		APPLICATION_IN_PROCESS: 4042006,

		APPROVED_BY_HEC: 4042007,
		REJECTED_BY_HEC: 4042008,
		REVISION_REQUESTED_BY_HEC: 4042009,
	};
	static DES_TABS = {
		PROFILE_DETAILS: 1,
		EDUCATION_DETAILS: 2,
		EQUIVALENCE_DETAILS: 3,
		UPLOAD_DETAILS: 4,
		VERIFY_DETAILS: 5,
	};

	static PROFILE_TABS = {
		PROFILE_DETAILS: 1,
		CONTACT_DETAILS: 2,
		EDUCATION_DETAILS: 3,
		CHANGE_PASSWORD: 4,
		CHANGE_EMAIL: 5,
		CHANGE_PHONE: 6,
	};

	static FEEDBACK_TYPES = {
		POOR: "Poor",
		FAIR: "Fair",
		GOOD: "Good",
		V_GOOD: "Very Good",
		EXCELLENT: "Excellent",
	};

	static Scheduling_Submission_Types = {
		self: 60032,
		authorize_persion: 60031,
		courier: 60033,
	};

	static SERVICES_TYPES = {
		DAS: "Degree Attestation Service",
		LOCAL_DES: "Local Degree Equivalence Service",
		FOREIGN_DES: "Foreign Degree Equivalence Service",
	};

	static IDENTIFICATION_TYPES = {
		CNIC: 60071,
		PASSPORT: 60072,
	};

	static ERROR_TYPES = {
		error: "error",
		success: "success",
		warning: "warning",
		FPP_REVIEW: "fppRevision",
		info: "info",
		Errorlist: "errorList",
		COURSERA_INFO: "coursera_info"
	};

	static ACRONYM_TYPES = {
		DAS: "DAS",
		LOCAL_DES: "DES",
		FOREIGN_DES: "DESF",
		ECOURSE: "COURSERA",
		PCD: "PCD",
	};

	static DES_URLS = {
		LOCAL_DES: "/localdes",
		FOREIGN_DES: "/foreigndes",
		MADARSA_DES: "/madarsades",
		LOCAL_DES_PAYMENT: "/des-payment",
		FOREIGN_DES_PAYMENT: "/desf-payment",
		FOREIGN_DES_ADMIN: "foreigntask-detail",
		LOCAL_DES_ADMIN: "task-detail",
		DES_FINAL_LETTER: "des-final-letter"
	};

	static DOWNLOAD_FORM_TYPE = {
		DAS_APPFORM: "DAS_AppForm",
		DAS_CHALLANFORM: "DAS_ChallanForm",
		DES_CHLLANFORM: "DES_LOCAL_CHALLAN",
		DESF_CHALLANFORM: "DES_FOREIGN_CHALLAN",
	};

	static GENDER_TYPES = {
		MALE: 10011,
		FEMALE: 10012,
		OTHER: 10013,
	};

	static USERNAME_TYPES = {
		CNIC: 1,
		PASSPORT: 2,
		POC: 3,
	};

	static AdminTypes = {
		DAS: "DAS",
		DES: "DES",
		ALL: "ALL",
	};

	static UserRoles = {
		ASSISTANT: "ASSISTANT",
		FINANCE: "FINANCE",
		ADMIN_VERIFICATION: "ADMIN_VERIFICATION",
		AD: "AD",
		DD: "DD",
		DIR: "DIR",
		DG: "DG",
		ED: "ED",
		MEMBER: "MEMBER",
		CHAIRMAN: "CHAIRMAN",
		Das_Scheduler_Admin: 'Das Scheduler Admin',
		DBV_ADMIN: "DAS_BLACKLISTED_VERIFICATION_PERSON",
		COURIER_ADMIN: "Courier Admin",
		COURSERA_FOCAL_PERSON: "FOCAL_PERSON",
		COURSERA_HEC_PERSON: "ADMIN",
		LOCAL_ADMIN_VERIFICATION: 'LOCAL_ADMIN_VERIFICATION',
		DAS_REGION_ADMIN: "Das_Region_Admin",
		DAS_STMAP_ADMIN: "Das_Stamp_Admin"
	};

	static COURSERA_STATUS = {
		SUBMITTED: "Submitted",
		APPROVED: "Approved By HEC",
		REJECTED: "Rejected By HEC",
		BLOCKED: "Blocked By HEC",
		// REJECTED:401409,
		// BLOCKED:401407,
		// APPROVED:401408,
		// SUBMITTED:401402,
	};

	static FOCAL_PERSONS = {
		HEC: 1,
		UNIVERSITY: 2,
		HEC_APPLICANT: "applicants",
		HEC_UNIVERSITY: "focalperson",
		FILTER_UNIVERSITY: "University",
		FILTER_PROVINCE: "Province",
	};

	static ForwardForeignOptionsAD = [
		{ label: "Forward to DD", value: "DD" },
		{ label: "Forward to DIR", value: "DIR" },
		{ label: "Forward to DG", value: "DG" },
		{ label: "Forward to ED", value: "ED" },
	];

	static ForwardOptionsAD = [];

	static ForwardOptionsDD = [
		{ label: "Forward to DIR", value: "DIR" },
		{ label: "Forward to DG", value: "DG" },
		{ label: "Forward to MEMBER", value: "MEMBER" },
		{ label: "Forward to ED", value: "ED" },
		{ label: "Forward to CHAIRMAN", value: "CHAIRMAN" },
	];

	static ForwardForeignOptionsDD = [
		{ label: "Forward to DIR", value: "DIR" },
		{ label: "Forward to DG", value: "DG" },
		{ label: "Forward to ED", value: "ED" },
	];

	static ForwardOptionsDIR = [
		{ label: "Forward to DG", value: "DG" },
		{ label: "Forward to MEMBER", value: "MEMBER" },
		{ label: "Forward to ED", value: "ED" },
		{ label: "Forward to CHAIRMAN", value: "CHAIRMAN" },
	];

	static ForwardForeignOptionsDIR = [
		{ label: "Forward to DG", value: "DG" },
		{ label: "Forward to ED", value: "ED" },
	];

	static ForwardOptionsDG = [
		{ label: "Forward to MEMBER", value: "MEMBER" },
		{ label: "Forward to ED", value: "ED" },
		{ label: "Forward to CHAIRMAN", value: "CHAIRMAN" },
	];

	static ForwardForeignOptionsDG = [{ label: "Forward to ED", value: "ED" }];

	static ForwardOptionsMEMBER = [
		{ label: "Forward to ED", value: "ED" },
		{ label: "Forward to CHAIRMAN", value: "CHAIRMAN" },
	];

	static ForwardOptionsED = [
		{ label: "Forward to CHAIRMAN", value: "CHAIRMAN" },
	];

	static SendBackOptionsAD = [
		{ label: "Send Back to Scrutiny", value: "ASSISTANT" },
	];

	static SendBackOptionsForeignAD = [
		{ label: "Send Back to Scrutiny", value: "ASSISTANT" },
	];

	static SendBackOptionsDD = [
		{ label: "Send Back to Scrutiny", value: "ASSISTANT" },
		{ label: "Send Back to AD", value: "AD" },
	];

	static SendBackOptionsForeignDD = [
		{ label: "Send Back to Scrutiny", value: "ASSISTANT" },
		{ label: "Send Back to AD", value: "AD" },
	];

	static SendBackOptionsDIR = [
		{ label: "Send Back to Scrutiny", value: "ASSISTANT" },
		{ label: "Send Back to AD", value: "AD" },
		{ label: "Send Back to DD", value: "DD" },
	];

	static SendBackOptionsForeignDIR = [
		{ label: "Send Back to Scrutiny", value: "ASSISTANT" },
		{ label: "Send Back to AD", value: "AD" },
		{ label: "Send Back to DD", value: "DD" },
	];

	static SendBackOptionsDG = [
		{ label: "Send Back to Scrutiny", value: "ASSISTANT" },
		{ label: "Send Back to AD", value: "AD" },
		{ label: "Send Back to DD", value: "DD" },
		{ label: "Send Back to DIR", value: "DIR" },
	];

	static SendBackOptionsForeignDG = [
		{ label: "Send Back to Scrutiny", value: "ASSISTANT" },
		{ label: "Send Back to AD", value: "AD" },
		{ label: "Send Back to DD", value: "DD" },
		{ label: "Send Back to DIR", value: "DIR" },
	];

	static SendBackOptionsMEMBER = [
		{ label: "Send Back to Scrutiny", value: "ASSISTANT" },
		{ label: "Send Back to AD", value: "AD" },
		{ label: "Send Back to DD", value: "DD" },
		{ label: "Send Back to DIR", value: "DIR" },
		{ label: "Send Back to DG", value: "DG" },
	];

	static SendBackOptionsED = [
		{ label: "Send Back to Scrutiny", value: "ASSISTANT" },
		{ label: "Send Back to AD", value: "AD" },
		{ label: "Send Back to DD", value: "DD" },
		{ label: "Send Back to DIR", value: "DIR" },
		{ label: "Send Back to DG", value: "DG" },
		{ label: "Send Back to MEMBER", value: "MEMBER" },
	];

	static SendBackOptionsForeignED = [
		{ label: "Send Back to Scrutiny", value: "ASSISTANT" },
		{ label: "Send Back to AD", value: "AD" },
		{ label: "Send Back to DD", value: "DD" },
		{ label: "Send Back to DIR", value: "DIR" },
		{ label: "Send Back to DG", value: "DG" },
	];

	static SendBackOptionsCHAIRMAN = [
		{ label: "Send Back to Scrutiny", value: "ASSISTANT" },
		{ label: "Send Back to AD", value: "AD" },
		{ label: "Send Back to DD", value: "DD" },
		{ label: "Send Back to DIR", value: "DIR" },
		{ label: "Send Back to DG", value: "DG" },
		{ label: "Send Back to MEMBER", value: "MEMBER" },
		{ label: "Send Back to ED", value: "ED" },
	];

	static DateFormat = {
		DD_MMM_YYYY: "DD MMM YYYY",
	};

	static APP_STATUS_RESPONSE = {
		FORWARDED_BY_DG: 900203,
		SENDBACK_BY_AD: 900202,
		SENDBACK_BY_DD: 900201,
	};

	static ScrutinyDecisions = [
		{ key: 600254, value: "Approve" },
		// { key: 600255, value: 'Reject' },
	];

	static ForeignScrutinyDecisions = [
		{ key: 600254, value: "Approve" },
		// { key: 600255, value: 'Reject' },
	];

	static ScrutinyDecisionsList = [
		{ key: 600254, value: "Approve" },
		// { key: 600255, value: 'Reject' },
		{ key: 600256, value: "Revision Required" },
	];

	static ForeignScrutinyDecisionsList = [
		{ key: 600254, value: "Approve" },
		{ key: 600255, value: "Reject" },
		{ key: 600256, value: "Revision Required" },
	];

	static ADDecisions = [
		{ key: 600257, value: "Approve" },
		{ key: 600258, value: "Reject" },
		{ key: 600259, value: "Revision Required" },
		{ key: 6002510, value: "Forward" },
	];

	static ForeignADDecisions = [
		{ key: 600257, value: "Approve" },
		{ key: 600258, value: "Reject" },
		{ key: 600259, value: "Revision Required" },
		{ key: 6002510, value: "Forward" },
	];

	static ForeignADDecisionList = [
		// { key: 600257, value: 'Approve' },
		{ key: 600258, value: "Reject" },
		// { key: 6002510, value: 'Forward' },
	];

	static ADDecisionsList = [
		{ key: 600257, value: "Approve" },
		{ key: 600258, value: "Reject" },
		{ key: 6002510, value: "Forward" },
	];

	static DDDecisions = [
		{ key: 6002511, value: "Approve" },
		{ key: 6002512, value: "Reject" },
		{ key: 6002513, value: "Revision Required" },
		{ key: 6002514, value: "Forward" },
	];

	static DDDecisionsList = [
		{ key: 6002511, value: "Approve" },
		{ key: 6002512, value: "Reject" },
		{ key: 6002514, value: "Forward" },
	];

	static ForeignDDDecisions = [
		{ key: 6002511, value: "Approve" },
		{ key: 6002512, value: "Reject" },
		{ key: 6002513, value: "Revision Required" },
		{ key: 6002514, value: "Forward" },
	];

	static ForeignDDDecisionsList = [
		// { key: 6002511, value: 'Approve' },
		{ key: 6002512, value: "Reject" },
		// { key: 6002518, value: 'Forward' },
	];

	static DirectorDecisions = [
		{ key: 6002515, value: "Approve" },
		{ key: 6002516, value: "Reject" },
		{ key: 6002517, value: "Revision Required" },
		{ key: 6002518, value: "Forward" },
	];

	static DirectorDecisionsList = [
		{ key: 6002515, value: "Approve" },
		{ key: 6002516, value: "Reject" },
		{ key: 6002518, value: "Forward" },
	];

	static ForeignDirectorDecisions = [
		{ key: 6002515, value: "Approve" },
		{ key: 6002516, value: "Reject" },
		{ key: 6002517, value: "Revision Required" },
		{ key: 6002518, value: "Forward" },
	];

	static ForeignDirectorDecisionsList = [
		{ key: 6002515, value: "Approve" },
		{ key: 6002516, value: "Reject" },
		// { key: 6002518, value: 'Forward' },
	];

	static DGDecisions = [
		{ key: 6002526, value: "Approve" },
		{ key: 6002527, value: "Reject" },
		{ key: 6002528, value: "Revision Required" },
		{ key: 6002529, value: "Forward" },
	];

	static DGDecisionsList = [
		{ key: 6002526, value: "Approve" },
		{ key: 6002527, value: "Reject" },
		{ key: 6002529, value: "Forward" },
	];

	static ForeignDGDecisions = [
		{ key: 6002526, value: "Approve" },
		{ key: 6002527, value: "Reject" },
		{ key: 6002528, value: "Revision Required" },
		{ key: 6002529, value: "Forward" }
	];

	static ForeignDGDecisionsList = [
		{ key: 6002526, value: "Approve" },
		{ key: 6002527, value: "Reject" },
	];

	static EDDecisions = [
		{ key: 6002519, value: "Approve" },
		{ key: 6002520, value: "Reject" },
		{ key: 6002521, value: "Revision Required" },
		{ key: 6002530, value: "Forward" },
	];

	static ForeignEDDecisionsList = [
		{ key: 6002519, value: "Approve" },
		{ key: 6002520, value: "Reject" },
		{ key: 6002530, value: "Forward" },
	];

	static ForeignEDDecisions = [
		{ key: 6002519, value: "Approve" },
		{ key: 6002520, value: "Reject" },
		{ key: 6002521, value: "Revision Required" },
		{ key: 6002530, value: "Forward" },
	];

	static EDDecisionsList = [
		{ key: 6002519, value: "Approve" },
		{ key: 6002520, value: "Reject" },
		{ key: 6002530, value: "Forward" },
	];

	static MemberDecisions = [
		{ key: 6002531, value: "Approve" },
		{ key: 6002532, value: "Reject" },
		{ key: 6002533, value: "Revision Required" },
		{ key: 6002534, value: "Forward" },
	];

	static MemberDecisionsList = [
		{ key: 6002531, value: "Approve" },
		{ key: 6002532, value: "Reject" },
		{ key: 6002534, value: "Forward" },
	];

	static ChairmanDecisions = [
		{ key: 6002535, value: "Approve" },
		{ key: 6002536, value: "Reject" },
		{ key: 6002537, value: "Revision Required" },
		{ key: 6002538, value: "Forward" },
	];

	static ChairmanDecisionsList = [
		{ key: 6002535, value: "Approve" },
		{ key: 6002536, value: "Reject" },
	];

	static FinanceDecisions = [
		{ key: 6002522, value: "Approve" },
		{ key: 6002523, value: "Reject" },
		{ key: 6002539, value: "Revision Required" },
	];

	static CombinedDecisionList = [
		{ key: 6002522, value: "Finance Approve" },
		{ key: 6002523, value: "Finance Reject" },
		{ key: 6002539, value: "Finance Revision Required" },
		{ key: 600254, value: "Scrutiny Approve" },
		{ key: 600255, value: "Scrutiny Reject" },
		{ key: 600253, value: "Clarification Submitted" },
		{ key: 600256, value: "Scrutiny Revision Required" },
		{ key: 600257, value: "AD Approve" },
		{ key: 600258, value: "AD Reject" },
		{ key: 600259, value: "AD Revision Required" },
		{ key: 6002510, value: "AD Forward" },
		{ key: 6002511, value: "DD Approve" },
		{ key: 6002512, value: "DD Reject" },
		{ key: 6002513, value: "DD Revision Required" },
		{ key: 6002514, value: "DD Forward" },
		{ key: 6002515, value: "DIR Approve" },
		{ key: 6002516, value: "DIR Reject" },
		{ key: 6002517, value: "DIR Revision Required" },
		{ key: 6002518, value: "DIR Forward" },
		{ key: 6002526, value: "DG Approve" },
		{ key: 6002527, value: "DG Reject" },
		{ key: 6002528, value: "DG Revision Required" },
		{ key: 6002529, value: "DG Forward" },
		{ key: 6002519, value: "ED Approve" },
		{ key: 6002520, value: "ED Reject" },
		{ key: 6002521, value: "ED Revision Required" },
		{ key: 6002530, value: "ED Forward" },
	];

	static DesTaskTitles = {
		Scrutiny: "SCRUTINY",
		ADApproval: "AD APPROVAL",
		DDApproval: "DD APPROVAL",
		DIRApproval: "DIR APPROVAL",
		DGApproval: "DG APPROVAL",
		EDApproval: "ED APPROVAL",
		MemberApproval: "MEMBER APPROVAL",
		ChairmanApproval: "CHAIRMAN APPROVAL",
		FinanceApproval: "FINANCE APPROVAL",
	};

	static ColorsList = {
		SEABLUE: "#07B1A3",
		LIGHTORANGE: "#FEBF67",
		NAVYBLUE: "#2E384D",
		LIGHTNAVYBLUE: "#3B43C5",
	};

	static roleList = {
		DG: 60,
		ADMIN: 59,
		CHAIRMAN: 58,
		MEMBER: 57,
		ED: 56,
		DIR: 55,
		DD: 54,
		FINANCE: 53,
		ASSISTANT: 52,
		University: 51,
		AD: 50
	};

	static PICTURE_SIZES = {
		max_width: 520,
		max_height: 350,
		slider_max_width: 1400,
		slider_max_height: 630,
		team_max_width: 500,
		team_max_height: 500,
		story_max_width: 260,
		story_max_height: 450,
	};

	static pageStates = {
		Add: 1,
		Edit: 2,
		View: 3,
		Delete: 4,
	};

	static JOB_SECTOR_OPTIONS = [
		{ label: 'Private', value: 'Private' },
		{ label: 'Public', value: 'Public' },

	];

}
